export const loanBuySideAdjustmentsSelector =
  (type?: any) =>
  ({ epps: { origin } }) => {
    // TODO check if this default value should be placed as initial store value
    if (type) return origin.buySideAdjustments[type] ?? [];
    return origin.buySideAdjustments;
  };
